import {addClass, find, findAll, removeClass} from "../../../../../modules/vegas/js/util";
import Cookies from 'js-cookie'

class VGCatalogGrid {
	constructor(btn) {
		this.element = find('.catalog-grid');
		this.button  = btn;
		this.target  = btn.dataset.target || '';
	}

	toggle() {
		let _this = this;

		if (_this.element && _this.target) {
			_this.element.setAttribute('data-grid', _this.target);

			Cookies.set('catalog-view-type', _this.target);

			removeClass(_this.button, 'active');

			let tools = _this.button.closest('.catalog-sort--tools-grid');
			findAll('.active', tools).forEach(function (el) {
				removeClass(el, 'active');
			});

			addClass(_this.button, 'active');

			localStorage.setItem('grid', _this.target);
		} else {
			console.error('Что то пошло не так')
		}
	}
}

export default VGCatalogGrid;
